import { all, fork } from "redux-saga/effects";
import questionnaire from "./questionnaire/sagas";
import questionnaireViewUpdate from "./questionnaireViewUpdate/sagas";
import providers from "./providers/sagas";
import schedule from "./schedule/sagas";
import callReports from "./callReports/sagas";
import callTakers from "./callTakers/sagas";
import returnCalls from "./returnCall/sagas";
import briefings from "./briefings/sagas";
import textBlasts from "./textBlasts/sagas";
import lessons from "./lessons/sagas";
import recognitions from "./recognitions/sagas";

export default function* rootSaga() {
  yield all([
    fork(questionnaire),
    fork(questionnaireViewUpdate),
    fork(providers),
    fork(schedule),
    fork(callReports),
    fork(callTakers),
    fork(returnCalls),
    fork(briefings),
    fork(textBlasts),
    fork(lessons),
    fork(recognitions),
  ]);
}
